import React, { useState } from "react";
import Moralis from "moralis";
import Web3 from "web3";
import button_spinner from "../images/Rolling.gif";
import noimage from "../images/noimage.png";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "font-awesome/css/font-awesome.min.css";
import { useHistory } from "react-router-dom";

const Singleminter = () => {
  var abi = [
    {
      inputs: [],
      stateMutability: "nonpayable",
      type: "constructor",
    },
    {
      anonymous: false,
      inputs: [
        {
          indexed: true,
          internalType: "address",
          name: "owner",
          type: "address",
        },
        {
          indexed: true,
          internalType: "address",
          name: "approved",
          type: "address",
        },
        {
          indexed: true,
          internalType: "uint256",
          name: "tokenId",
          type: "uint256",
        },
      ],
      name: "Approval",
      type: "event",
    },
    {
      anonymous: false,
      inputs: [
        {
          indexed: true,
          internalType: "address",
          name: "owner",
          type: "address",
        },
        {
          indexed: true,
          internalType: "address",
          name: "operator",
          type: "address",
        },
        {
          indexed: false,
          internalType: "bool",
          name: "approved",
          type: "bool",
        },
      ],
      name: "ApprovalForAll",
      type: "event",
    },
    {
      inputs: [
        {
          internalType: "address",
          name: "to",
          type: "address",
        },
        {
          internalType: "uint256",
          name: "tokenId",
          type: "uint256",
        },
      ],
      name: "approve",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      inputs: [
        {
          internalType: "uint256",
          name: "tokenId",
          type: "uint256",
        },
      ],
      name: "awardWinner",
      outputs: [],
      stateMutability: "payable",
      type: "function",
    },
    {
      inputs: [
        {
          internalType: "uint256",
          name: "tokenId",
          type: "uint256",
        },
      ],
      name: "burn",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      inputs: [
        {
          internalType: "uint256",
          name: "tokenId",
          type: "uint256",
        },
      ],
      name: "buyNft",
      outputs: [],
      stateMutability: "payable",
      type: "function",
    },
    {
      inputs: [
        {
          internalType: "uint256",
          name: "tokenId",
          type: "uint256",
        },
      ],
      name: "closeAuction",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      inputs: [
        {
          internalType: "address",
          name: "to",
          type: "address",
        },
        {
          internalType: "string",
          name: "uri",
          type: "string",
        },
        {
          internalType: "uint256",
          name: "price",
          type: "uint256",
        },
        {
          internalType: "uint256",
          name: "saleNumber",
          type: "uint256",
        },
        {
          internalType: "uint256",
          name: "auctionTime",
          type: "uint256",
        },
        {
          internalType: "uint256",
          name: "royality",
          type: "uint256",
        },
      ],
      name: "mintToken",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      anonymous: false,
      inputs: [
        {
          indexed: true,
          internalType: "address",
          name: "previousOwner",
          type: "address",
        },
        {
          indexed: true,
          internalType: "address",
          name: "newOwner",
          type: "address",
        },
      ],
      name: "OwnershipTransferred",
      type: "event",
    },
    {
      inputs: [],
      name: "pause",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      anonymous: false,
      inputs: [
        {
          indexed: false,
          internalType: "address",
          name: "account",
          type: "address",
        },
      ],
      name: "Paused",
      type: "event",
    },
    {
      inputs: [
        {
          internalType: "uint256",
          name: "tokenId",
          type: "uint256",
        },
        {
          internalType: "uint256",
          name: "bidAmount",
          type: "uint256",
        },
        {
          internalType: "address",
          name: "mmo_address",
          type: "address",
        },
      ],
      name: "placeBid",
      outputs: [],
      stateMutability: "payable",
      type: "function",
    },
    {
      inputs: [
        {
          internalType: "uint256",
          name: "tokenId",
          type: "uint256",
        },
      ],
      name: "purchase",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      inputs: [
        {
          internalType: "uint256",
          name: "tokenId",
          type: "uint256",
        },
        {
          internalType: "uint256",
          name: "auctionTimeNeeded",
          type: "uint256",
        },
        {
          internalType: "uint256",
          name: "minPrice",
          type: "uint256",
        },
      ],
      name: "putOnAuction",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      inputs: [
        {
          internalType: "uint256",
          name: "tokenId",
          type: "uint256",
        },
        {
          internalType: "uint256",
          name: "price",
          type: "uint256",
        },
      ],
      name: "putOnSale",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      inputs: [
        {
          internalType: "uint256",
          name: "tokenId",
          type: "uint256",
        },
      ],
      name: "removeNft",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      inputs: [],
      name: "renounceOwnership",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      inputs: [
        {
          internalType: "uint256",
          name: "tokenId",
          type: "uint256",
        },
      ],
      name: "retriveFromSale",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      inputs: [
        {
          internalType: "address",
          name: "to",
          type: "address",
        },
        {
          internalType: "string",
          name: "uri",
          type: "string",
        },
      ],
      name: "safeMint",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      inputs: [
        {
          internalType: "address",
          name: "from",
          type: "address",
        },
        {
          internalType: "address",
          name: "to",
          type: "address",
        },
        {
          internalType: "uint256",
          name: "tokenId",
          type: "uint256",
        },
      ],
      name: "safeTransferFrom",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      inputs: [
        {
          internalType: "address",
          name: "from",
          type: "address",
        },
        {
          internalType: "address",
          name: "to",
          type: "address",
        },
        {
          internalType: "uint256",
          name: "tokenId",
          type: "uint256",
        },
        {
          internalType: "bytes",
          name: "_data",
          type: "bytes",
        },
      ],
      name: "safeTransferFrom",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      inputs: [
        {
          internalType: "address",
          name: "operator",
          type: "address",
        },
        {
          internalType: "bool",
          name: "approved",
          type: "bool",
        },
      ],
      name: "setApprovalForAll",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      anonymous: false,
      inputs: [
        {
          indexed: true,
          internalType: "address",
          name: "from",
          type: "address",
        },
        {
          indexed: true,
          internalType: "address",
          name: "to",
          type: "address",
        },
        {
          indexed: true,
          internalType: "uint256",
          name: "tokenId",
          type: "uint256",
        },
      ],
      name: "Transfer",
      type: "event",
    },
    {
      inputs: [
        {
          internalType: "address",
          name: "newOwner",
          type: "address",
        },
      ],
      name: "transferOwnership",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      anonymous: false,
      inputs: [
        {
          indexed: false,
          internalType: "address",
          name: "account",
          type: "address",
        },
      ],
      name: "Unpaused",
      type: "event",
    },
    {
      anonymous: false,
      inputs: [
        {
          indexed: false,
          internalType: "uint256",
          name: "id",
          type: "uint256",
        },
        {
          indexed: false,
          internalType: "string",
          name: "uri",
          type: "string",
        },
      ],
      name: "tokenMinted",
      type: "event",
    },
    {
      inputs: [
        {
          internalType: "address",
          name: "from",
          type: "address",
        },
        {
          internalType: "address",
          name: "to",
          type: "address",
        },
        {
          internalType: "uint256",
          name: "tokenId",
          type: "uint256",
        },
      ],
      name: "transferFrom",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      inputs: [
        {
          internalType: "address",
          name: "receiver",
          type: "address",
        },
        {
          internalType: "uint256",
          name: "amount",
          type: "uint256",
        },
        {
          internalType: "address",
          name: "mmoAddress",
          type: "address",
        },
      ],
      name: "transfermmo",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      inputs: [],
      name: "unpause",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      inputs: [
        {
          internalType: "uint256",
          name: "tokenId",
          type: "uint256",
        },
        {
          internalType: "uint256",
          name: "price",
          type: "uint256",
        },
      ],
      name: "updatePrice",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      inputs: [
        {
          internalType: "address",
          name: "owner",
          type: "address",
        },
      ],
      name: "balanceOf",
      outputs: [
        {
          internalType: "uint256",
          name: "",
          type: "uint256",
        },
      ],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [
        {
          internalType: "uint256",
          name: "tokenId",
          type: "uint256",
        },
      ],
      name: "getApproved",
      outputs: [
        {
          internalType: "address",
          name: "",
          type: "address",
        },
      ],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [
        {
          internalType: "uint256",
          name: "tokenId",
          type: "uint256",
        },
      ],
      name: "getAuctionWinner",
      outputs: [
        {
          internalType: "address",
          name: "",
          type: "address",
        },
      ],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [
        {
          internalType: "string",
          name: "uri",
          type: "string",
        },
      ],
      name: "getIdbyUri",
      outputs: [
        {
          internalType: "uint256",
          name: "",
          type: "uint256",
        },
      ],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [
        {
          internalType: "uint256",
          name: "tokenId",
          type: "uint256",
        },
      ],
      name: "getMinBidPrice",
      outputs: [
        {
          internalType: "uint256",
          name: "",
          type: "uint256",
        },
      ],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [
        {
          internalType: "uint256",
          name: "tokenId",
          type: "uint256",
        },
      ],
      name: "getNftCreator",
      outputs: [
        {
          internalType: "address",
          name: "",
          type: "address",
        },
      ],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [
        {
          internalType: "uint256",
          name: "tokenId",
          type: "uint256",
        },
      ],
      name: "getNftRoyality",
      outputs: [
        {
          internalType: "uint256",
          name: "",
          type: "uint256",
        },
      ],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [
        {
          internalType: "uint256",
          name: "tokenId",
          type: "uint256",
        },
      ],
      name: "getNumberOfBids",
      outputs: [
        {
          internalType: "uint256",
          name: "",
          type: "uint256",
        },
      ],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [
        {
          internalType: "uint256",
          name: "tokenId",
          type: "uint256",
        },
      ],
      name: "getPrice",
      outputs: [
        {
          internalType: "uint256",
          name: "",
          type: "uint256",
        },
      ],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [
        {
          internalType: "uint256",
          name: "tokenId",
          type: "uint256",
        },
      ],
      name: "getRemainingBidingTime",
      outputs: [
        {
          internalType: "uint256",
          name: "",
          type: "uint256",
        },
      ],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [
        {
          internalType: "uint256",
          name: "tokenId",
          type: "uint256",
        },
      ],
      name: "getRunnerup",
      outputs: [
        {
          internalType: "address",
          name: "",
          type: "address",
        },
      ],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [
        {
          internalType: "uint256",
          name: "tokenId",
          type: "uint256",
        },
      ],
      name: "getRunnerupBid",
      outputs: [
        {
          internalType: "uint256",
          name: "",
          type: "uint256",
        },
      ],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [
        {
          internalType: "uint256",
          name: "tokenId",
          type: "uint256",
        },
      ],
      name: "getWinningBid",
      outputs: [
        {
          internalType: "uint256",
          name: "",
          type: "uint256",
        },
      ],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [
        {
          internalType: "uint256",
          name: "tokenId",
          type: "uint256",
        },
      ],
      name: "getWinningBider",
      outputs: [
        {
          internalType: "address",
          name: "",
          type: "address",
        },
      ],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [
        {
          internalType: "address",
          name: "owner",
          type: "address",
        },
        {
          internalType: "address",
          name: "operator",
          type: "address",
        },
      ],
      name: "isApprovedForAll",
      outputs: [
        {
          internalType: "bool",
          name: "",
          type: "bool",
        },
      ],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [
        {
          internalType: "uint256",
          name: "tokenId",
          type: "uint256",
        },
      ],
      name: "isNftForSale",
      outputs: [
        {
          internalType: "bool",
          name: "",
          type: "bool",
        },
      ],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [
        {
          internalType: "uint256",
          name: "tokenId",
          type: "uint256",
        },
      ],
      name: "isNftOnAuction",
      outputs: [
        {
          internalType: "bool",
          name: "",
          type: "bool",
        },
      ],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [],
      name: "name",
      outputs: [
        {
          internalType: "string",
          name: "",
          type: "string",
        },
      ],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [],
      name: "owner",
      outputs: [
        {
          internalType: "address",
          name: "",
          type: "address",
        },
      ],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [
        {
          internalType: "uint256",
          name: "tokenId",
          type: "uint256",
        },
      ],
      name: "ownerOf",
      outputs: [
        {
          internalType: "address",
          name: "",
          type: "address",
        },
      ],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [],
      name: "paused",
      outputs: [
        {
          internalType: "bool",
          name: "",
          type: "bool",
        },
      ],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [
        {
          internalType: "bytes4",
          name: "interfaceId",
          type: "bytes4",
        },
      ],
      name: "supportsInterface",
      outputs: [
        {
          internalType: "bool",
          name: "",
          type: "bool",
        },
      ],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [],
      name: "symbol",
      outputs: [
        {
          internalType: "string",
          name: "",
          type: "string",
        },
      ],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [
        {
          internalType: "uint256",
          name: "index",
          type: "uint256",
        },
      ],
      name: "tokenByIndex",
      outputs: [
        {
          internalType: "uint256",
          name: "",
          type: "uint256",
        },
      ],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [
        {
          internalType: "address",
          name: "owner",
          type: "address",
        },
        {
          internalType: "uint256",
          name: "index",
          type: "uint256",
        },
      ],
      name: "tokenOfOwnerByIndex",
      outputs: [
        {
          internalType: "uint256",
          name: "",
          type: "uint256",
        },
      ],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [
        {
          internalType: "uint256",
          name: "tokenId",
          type: "uint256",
        },
      ],
      name: "tokenURI",
      outputs: [
        {
          internalType: "string",
          name: "",
          type: "string",
        },
      ],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [],
      name: "totalSupply",
      outputs: [
        {
          internalType: "uint256",
          name: "",
          type: "uint256",
        },
      ],
      stateMutability: "view",
      type: "function",
    },
  ];

  const [picture, setPicture] = useState(null);
  const [imgData, setImgData] = useState(noimage);
  const onChangePicture = (e) => {
    if (e.target.files[0]) {
      console.log("picture: ", e.target.files);
      setPicture(e.target.files[0]);
      const reader = new FileReader();
      reader.addEventListener("load", () => {
        setImgData(reader.result);
      });
      reader.readAsDataURL(e.target.files[0]);
    }
  };
  var isFixedPrice = false;
  var isAuction = false;
  //var saleNumber = 0;
  //var auctionTimeSeconds = 0;

  const [loading, setLoading] = useState(false);
  Moralis.initialize("lGFqxutUnQZXqqxy5N1optlMEzpT6RJW7BwbcMmw");
  Moralis.serverURL = "https://kquqmy2unesf.usemoralis.com:2053/server";
  let history = useHistory();
  async function ipfsUpload() {
    const name = document.getElementById("nftname").value;
    const description = document.getElementById("nftdescription").value;
    const properties = document.getElementById("nftproperties").value;
    //const category = document.getElementById("nftcat").value;
    const royalty = document.getElementById("royalty").value;
    var price = document.getElementById("price").value;

    // const numberOf = document.getElementById("numberof").value;
    // const auctionTime = document.getElementById("numberof").value;

    // const putOnSale = document.getElementById("putonsale_check").checked;
    //alert(putOnSale);

    if (!name) {
      document.getElementById("name-val").innerHTML = "Required Field";
    } else if (!description) {
      document.getElementById("desc-val").innerHTML = "Required Field";
    } else if (!properties) {
      document.getElementById("properties-val").innerHTML = "Required Field";
    } else if (!royalty) {
      document.getElementById("royality-val").innerHTML = "Required Field";
    } else if (royalty > 10) {
      document.getElementById("royality-val").innerHTML =
        "Maximum 10% Royality Allowed";
    } else if (isFixedPrice) {
      setLoading(true);
      const imgUrl = await imgUpload();
      const metadataUrl = await metadataUpload(imgUrl);
      //console.log(metadataUrl);

      //put it on blockchain
      const contract_address = "0x0c24491c7CadACc878474047c5d7972340D392C3";
      const contract_abi = abi;
      const web3 = new Web3(window.ethereum);
      const accounts = await web3.eth.getAccounts();
      const contract = new web3.eth.Contract(contract_abi, contract_address);
      const saleNum = 1;
      const priceInWei = web3.utils.toWei(price, "ether");
      /* console.log("account:  "+ accounts[0] + " meta:  " + metadataUrl+ " Price:  " + price + " saleNumber:  " + saleNum + " auction Seconds:  " + auctionTimeSeconds + "Royality:  " + royalty);
      alert("fixed Price is "+ isFixedPrice +" so executing fixed price function"); */
      contract.methods
        .mintToken(accounts[0], metadataUrl, priceInWei, saleNum, 0, royalty)
        .send({ from: accounts[0] })
        .then(function (mintTokenRes) {
          if (mintTokenRes.status) {
            toast.success("Congrats!!! NFT minted Successfully", {
              theme: "colored",
            });
            setLoading(false);
            setTimeout(function () {
              //  window.location.reload(true);

              history.push("/myitems");
            }, 6000);
          } else if (!mintTokenRes.status) {
            // alert("An error accoured. Please try again");
            toast.error("An error accoured. Please try again", {
              theme: "colored",
            });
            setLoading(false);
          }
        });
    } else if (isAuction) {
      setLoading(true);
      const imgUrl = await imgUpload();
      const metadataUrl = await metadataUpload(imgUrl);
      //console.log(metadataUrl);

      //put it on blockchain
      const contract_address = "0x0c24491c7CadACc878474047c5d7972340D392C3";
      const contract_abi = abi;
      const web3 = new Web3(window.ethereum);
      const accounts = await web3.eth.getAccounts();
      const contract = new web3.eth.Contract(contract_abi, contract_address);
      const numberOf = document.getElementById("numberof").value;
      const minimumBid = document.getElementById("minbid").value;
      const minBidInWei = web3.utils.toWei(minimumBid, "ether");
      //alert(minBidInWei);

      let auctionTimeNeeded = 0;
      const dayOrHours = document.getElementById("auctiontime").value;
      if (dayOrHours === "days") {
        auctionTimeNeeded = numberOf * 24 * 60 * 60;
      } else if (dayOrHours === "hours") {
        auctionTimeNeeded = numberOf * 60 * 60;
      }
      // alert( " auction Seconds:  " + auctionTimeNeeded);

      contract.methods
        .mintToken(
          accounts[0],
          metadataUrl,
          minBidInWei,
          2,
          auctionTimeNeeded,
          royalty
        )
        .send({ from: accounts[0] })
        .then(function (mintTokenRes) {
          if (mintTokenRes.status) {
            toast.success("Congrats!!! NFT minted Successfully", {
              theme: "colored",
            });
            setLoading(false);
            setTimeout(function () {
              //window.location.reload(true);

              history.push("/myitems");
            }, 6000);
          } else if (!mintTokenRes.status) {
            // alert("An error accoured. Please try again");
            toast.error("An error accoured. Please try again", {
              theme: "colored",
            });
            setLoading(false);
          }
        });
      const check = await contract.methods.getPrice("0").call();
      console.log(check);

      // contract.methods.name().call().then(function(res){alert(res)});
    }
  }

  function handleCheckEvent() {
    var checkState = document.getElementById("putonsale_check").checked;
    var SaleElement = document.getElementById("saleType");
    var fixedPriceDiv = document.getElementById("pricediv");

    if (checkState) {
      SaleElement.style.display = "block";
      fixedPriceDiv.style.display = "block";
      isFixedPrice = true;
      // alert("FixedPrice : "+isFixedPrice);
      // alert("Auction : "+isAuction);
    } else {
      SaleElement.style.display = "none";
    }
  }
  function fixedPriceHandler() {
    var fixedPriceDiv = document.getElementById("pricediv");
    var auctionDiv = document.getElementById("auctiondiv");
    auctionDiv.style.display = "none";
    fixedPriceDiv.style.display = "block";
    isFixedPrice = true;
    isAuction = false;
    //alert("FixedPrice : "+isFixedPrice);
    //alert("Auction : "+isAuction);
  }

  function auctionBtnHandler() {
    var fixedPriceDiv = document.getElementById("pricediv");
    var auctionDiv = document.getElementById("auctiondiv");
    fixedPriceDiv.style.display = "none";
    auctionDiv.style.display = "block";
    isAuction = true;
    isFixedPrice = false;
    //alert("FixedPrice : "+isFixedPrice);
    //alert("Auction : "+isAuction);
  }

  async function imgUpload() {
    const data = document.querySelector("input[type=file]").files[0];
    const file = new Moralis.File(data.name, data);
    await file.saveIPFS();
    //console.log(file.ipfs());
    return file.ipfs();
  }
  async function metadataUpload(imgUrl) {
    /*get input values*/
    const name = document.getElementById("nftname").value;
    const description = document.getElementById("nftdescription").value;
    const properties = document.getElementById("nftproperties").value;
    const category = document.getElementById("nftcat").value;
    const royalty = document.getElementById("royalty").value;
    //const putOnSale = document.getElementById("putonsale_check").value;

    /*data object*/
    const metadata = {
      image: imgUrl,
      nftName: name,
      nftDescription: description,
      nftProperties: properties,
      category: category,
      royalty: royalty,
    };
    const file = new Moralis.File("file.jason", {
      base64: btoa(JSON.stringify(metadata)),
    });
    await file.saveIPFS();
    // console.log(file.ipfs());
    return file.ipfs();
  }

  return (
    <from>
      <ToastContainer />
      <div className="container-fluid row minter-outer-div">
        <div className="col-md-5 preview-outer">
          <h4> Preview</h4>
          <div className="preview-div-wrapper">
            <div className="preview-div" id="preview-div">
              <form runat="server">
                <img
                  id="blah"
                  src={imgData}
                  alt="NO IMAGE PREVIEW IS AVAILABEL FOR THIS FILE"
                  width="280px"
                  height="330px"
                />
              </form>
            </div>
          </div>

          <div className="upload-button-div">
            <label for="nftImg" id="imgUploadReplaceLabel">
              Upload file
              <p className="upload_inner_text">
                {" "}
                PNG, GIF, WEBP or MP4. Max 100mb.
              </p>
            </label>
            <input type="file" id="nftImg" onChange={onChangePicture} hidden />
          </div>
        </div>

        <div className="col-md-6 mint-col-1">
          <label for="name">Name</label>
          <input type="text" id="nftname" placeholder="eg: Smith" required />
          <label for="name-val" id="name-val"></label>

          <label for="description">Description</label>
          <input
            type="text"
            id="nftdescription"
            placeholder="describe your NFT"
            required
          />
          <label for="desc-val" id="desc-val"></label>

          <label for="properties">Properties</label>
          <input
            type="text"
            id="nftproperties"
            placeholder="eg:size"
            required
          />
          <label for="properties-val" id="properties-val"></label>

          <label for="roaylity">Roylity (Maximum 10%)</label>
          <input
            type="number"
            id="royalty"
            placeholder="0-10"
            min="1"
            max="10"
          />
          <label for="royality-val" id="royality-val"></label>

          <label for="category">Category</label>
          <select name="categoryselect" id="nftcat">
            <option value="art">ART</option>
            <option value="sports">Sports</option>
            <option value="entertainment">Entertainment</option>
            <option value="gaming">Gaming</option>
            <option value="collectibles">Collectibles</option>
            <option value="esports">Esports</option>
            <option value="nftforgood">NFT for Good </option>
          </select>

          <div className="row putonsale_wrapper">
            <div className="col-md-10">
              <label id="putonsaleswitch"> Put on Sale</label>
            </div>
            <div className="col-md-2 putonsale_switch_div">
              <input
                type="checkbox"
                id="putonsale_check"
                onClick={handleCheckEvent}
              />
              <label id="putonsale-val"></label>
            </div>
          </div>

          <div id="saleType" className="hide sale_warpper-div">
            <span className="fixed-price-span">
              <button className="saleTypeBtn" onClick={fixedPriceHandler}>
                <i className="fa fa-tags"></i>
                <h6>Fixed Price</h6>
              </button>
            </span>
            <span className="auction-span">
              <button className="saleTypeBtn" onClick={auctionBtnHandler}>
                <i className="fa fa-rocket"></i>
                <h6>Timed Auction</h6>
              </button>
            </span>

            <div id="pricediv" className="hide">
              <label for="price">Price (MMO)</label>
              <input type="number" id="price" min="1" />
              <label for="price-val" id="price-val"></label>
            </div>

            <div id="auctiondiv" className="hide">
              <label for="price"> Minimum Bid (MMO)</label>
              <input type="number" id="minbid" min="1" />
              <label for="price-val" id="price-val"></label>

              <div id="" className="">
                <label for="price"> Expiration Time </label>
                <span className="expiretime-sapn-1">
                  <input type="number" id="numberof" min="1" />
                </span>
                <span className="expiretime-sapn-2">
                  <select name="timeselect" id="auctiontime">
                    <option value="days">Days</option>
                    <option value="hours">Hours</option>
                  </select>
                </span>
              </div>
            </div>
          </div>

          <button className="mint-btn" onClick={ipfsUpload}>
            {!loading && "Create Item"}
            {loading && (
              <span>
                <img src={button_spinner} width="25px" height="25px" /> Please
                wait....
              </span>
            )}
          </button>
        </div>

        {/*Empty Div*/}
        <div className="col-md-1"></div>
      </div>
    </from>
  );
};

export default Singleminter;
